import { Consent } from '@/hooks/useRegistrationStore';

export const UK_RESIDENTS_TC_STEP = 'uk_nirl_nursing_home';

export const CONSENTS_STEPS_WITH_RADIO_BUTTONS = [UK_RESIDENTS_TC_STEP];

export const MINOR_CONSENT_STEPS = new Set([
  'minor_okay',
]);

export const isMinorConfirmConsent = (consent: Consent) =>
  MINOR_CONSENT_STEPS.has(consent.systemId);

export const isOptionSelectConsent = (consent: Consent) =>
  CONSENTS_STEPS_WITH_RADIO_BUTTONS.includes(consent.systemId); 

export const isHtmlContent = (content: string): boolean => {
  if (!content) return false;
  
  // Check for HTML tags (opening or closing)
  const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
  
  // Check for HTML entities
  const htmlEntityRegex = /&[a-z]+;|&#\d+;/i;
  
  return htmlTagRegex.test(content) || htmlEntityRegex.test(content);
};